import bridgeData from '../content/story_bridge.json';

export function getBridge(storyId) {
  return bridgeData.bridges.find((b) => b.story_id === storyId) || null;
}

export function hasBridge(storyId) {
  return !!getBridge(storyId);
}

export const ALL_BRIDGES = bridgeData.bridges;
